import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AppsIcon from '@mui/icons-material/Apps';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import AppBar from '@mui/material/AppBar';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { SIDEBAR_WIDTH } from './SidePanel';
function getInitials(name) {
    return name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0].toUpperCase())
        .join('');
}
const ROLE_DISPLAY_LABELS = {
    admin: 'Admin',
    viewer: 'User'
};
function roleDisplayLabel(role) {
    return ROLE_DISPLAY_LABELS[role] ?? role;
}
const TopBar = ({ sidebarOpen, onSidebarToggle, title, centerSlot, endSlot }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    return (_jsx(AppBar, { position: "fixed", sx: {
            zIndex: (theme) => theme.zIndex.drawer + 1,
            transition: (theme) => theme.transitions.create(['width', 'margin'], {
                easing: theme.transitions.easing.sharp,
                duration: sidebarOpen
                    ? theme.transitions.duration.enteringScreen
                    : theme.transitions.duration.leavingScreen
            }),
            ...(sidebarOpen && { ml: `${SIDEBAR_WIDTH}px`, width: `calc(100% - ${SIDEBAR_WIDTH}px)` })
        }, children: _jsxs(Toolbar, { children: [_jsx(IconButton, { color: "inherit", "aria-label": sidebarOpen ? 'close sidebar' : 'open sidebar', onClick: onSidebarToggle, edge: "start", sx: { mr: 2 }, children: sidebarOpen ? _jsx(MenuOpenIcon, {}) : _jsx(MenuIcon, {}) }), _jsx(Typography, { variant: "h6", noWrap: true, component: "div", sx: { mr: 2 }, children: title ?? 'MFGDM Backoffice' }), _jsx(Box, { sx: { flexGrow: 1 }, children: centerSlot }), endSlot, _jsx(Button, { color: "inherit", size: "small", startIcon: _jsx(AppsIcon, {}), onClick: () => navigate('/tools'), sx: { mr: 2, textTransform: 'none', whiteSpace: 'nowrap' }, children: "All Tools" }), user && (_jsxs(_Fragment, { children: [_jsx(IconButton, { onClick: (e) => setAnchorEl(e.currentTarget), sx: { p: 0 }, children: _jsx(Avatar, { sx: {
                                    width: 34,
                                    height: 34,
                                    fontSize: 13,
                                    fontWeight: 700,
                                    bgcolor: 'primary.dark',
                                    cursor: 'pointer'
                                }, children: getInitials(user.name) }) }), _jsxs(Menu, { anchorEl: anchorEl, open: Boolean(anchorEl), onClose: () => setAnchorEl(null), transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' }, slotProps: { paper: { sx: { minWidth: 200, mt: 1 } } }, children: [_jsxs(Box, { sx: { px: 2, py: 1.5 }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [_jsx(Typography, { variant: "body2", fontWeight: 600, noWrap: true, children: user.name }), _jsx(Chip, { label: roleDisplayLabel(user.role), size: "small", sx: { height: 20 } })] }), _jsx(Typography, { variant: "caption", color: "text.secondary", noWrap: true, display: "block", children: user.email })] }), _jsx(Divider, {}), _jsxs(MenuItem, { onClick: () => {
                                        setAnchorEl(null);
                                        logout();
                                    }, sx: { mt: 0.5 }, children: [_jsx(ListItemIcon, { children: _jsx(LogoutIcon, { fontSize: "small" }) }), _jsx(Typography, { variant: "body2", children: "Sign out" })] })] })] }))] }) }));
};
export default TopBar;
